import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-center" }
const _hoisted_2 = {
  key: 0,
  class: "mb-3"
}
const _hoisted_3 = {
  class: "mb-0",
  style: {"white-space":"pre-line"}
}

import { computed } from 'vue';
import BaseModal from './BaseModal.vue';


export default {
  __name: 'ConfirmationDialog',
  props: {
  show: { type: Boolean, default: false },
  title: { type: String, default: 'Bestätigung erforderlich' },
  message: { type: String, default: 'Möchten Sie fortfahren?' },
  confirmText: { type: String, default: 'Bestätigen' },
  cancelText: { type: String, default: 'Abbrechen' },
  showCancel: { type: Boolean, default: true },
  confirmButtonClass: { type: String, default: 'btn btn-primary' },
  icon: { type: String, default: '' }, // 'warning', 'danger', 'info', 'success'
  confirmIcon: { type: String, default: '' }
},
  emits: ['close', 'confirm'],
  setup(__props) {

const props = __props;



const iconClasses = computed(() => {
  const iconMap = {
    warning: 'fas fa-exclamation-triangle text-warning',
    danger: 'fas fa-exclamation-circle text-danger',
    info: 'fas fa-info-circle text-info',
    success: 'fas fa-check-circle text-success'
  };
  
  return iconMap[props.icon] || props.icon;
});

return (_ctx, _cache) => {
  return (_openBlock(), _createBlock(BaseModal, {
    show: __props.show,
    title: __props.title,
    size: "md",
    "modal-id": "confirmationModal",
    onClose: _cache[2] || (_cache[2] = $event => (_ctx.$emit('close')))
  }, {
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (__props.icon)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("i", {
                class: _normalizeClass(iconClasses.value),
                style: {"font-size":"3rem"}
              }, null, 2 /* CLASS */)
            ]))
          : _createCommentVNode("v-if", true),
        _createElementVNode("p", _hoisted_3, _toDisplayString(__props.message), 1 /* TEXT */)
      ])
    ]),
    footer: _withCtx(() => [
      (__props.showCancel)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            type: "button",
            class: "btn btn-secondary",
            onClick: _cache[0] || (_cache[0] = $event => (_ctx.$emit('close')))
          }, _toDisplayString(__props.cancelText), 1 /* TEXT */))
        : _createCommentVNode("v-if", true),
      _createElementVNode("button", {
        type: "button",
        class: _normalizeClass(__props.confirmButtonClass),
        onClick: _cache[1] || (_cache[1] = $event => (_ctx.$emit('confirm')))
      }, [
        (__props.confirmIcon)
          ? (_openBlock(), _createElementBlock("i", {
              key: 0,
              class: _normalizeClass([__props.confirmIcon, "me-2"])
            }, null, 2 /* CLASS */))
          : _createCommentVNode("v-if", true),
        _createTextVNode(" " + _toDisplayString(__props.confirmText), 1 /* TEXT */)
      ], 2 /* CLASS */)
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["show", "title"]))
}
}

}